import {
    UiStack,
    UiSuspensefulOutlet,
} from '@experiences/ui-common';
import { PortalErrorPage } from '@uipath/portal-shell-react';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { isOrgAdminSelector } from '../../store/selectors';

// Client-side gate only — the governance APIs must enforce org-admin server-side.
const GovernanceV2OrgAdminGuard: React.FC = () => {
    const { formatMessage: translate } = useIntl();
    const isOrgAdmin = useSelector(isOrgAdminSelector);

    if (isOrgAdmin) {
        return <UiSuspensefulOutlet />;
    }

    return (
        <UiStack
            justify="center"
            align="center"
            data-cy="governance-v2-policy-forbidden"
            style={{
                minHeight: '100%',
                width: '100%',
            }}>
            <PortalErrorPage
                type="403"
                buttonText={translate({ id: 'CLIENT_REFRESH_PAGE' })}
                buttonHref={globalThis.location.href} />
        </UiStack>
    );
};

export default GovernanceV2OrgAdminGuard;
